import type { ProductDefinition } from "@/types/orders";

// Centralized product catalog with removable ingredients
// This is the single source of truth for product definitions

export const PRODUCT_CATALOG: ProductDefinition[] = [
  // === BEBIDAS FRÍAS ===
  { id: "zumo", name: "Zumo", price: 1.60, category: "Bebidas Frías", subcategory: "Refrescos y Zumos" },
  { id: "refresco", name: "Refresco", price: 1.60, category: "Bebidas Frías", subcategory: "Refrescos y Zumos" },
  { id: "nestea", name: "Nestea", price: 1.70, category: "Bebidas Frías", subcategory: "Refrescos y Zumos" },
  { id: "agua", name: "Agua", price: 0.60, category: "Bebidas Frías", subcategory: "Refrescos y Zumos" },
  { 
    id: "zumo-naranja-peq", 
    name: "Zumo de Naranja Pequeño", 
    price: 2.80, 
    category: "Bebidas Frías", 
    subcategory: "Zumo de Naranja Natural",
    customizationGroups: [
      {
        id: "temperatura",
        title: "🌡️ Temperatura",
        required: false,
        type: "radio",
        options: [
          { id: "natural", label: "Natural (del tiempo)", price: 0 },
          { id: "frio", label: "Frío (con hielo)", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "zumo-naranja-gde", 
    name: "Zumo de Naranja Grande", 
    price: 3.50, 
    category: "Bebidas Frías", 
    subcategory: "Zumo de Naranja Natural",
    customizationGroups: [
      {
        id: "temperatura",
        title: "🌡️ Temperatura",
        required: false,
        type: "radio",
        options: [
          { id: "natural", label: "Natural (del tiempo)", price: 0 },
          { id: "frio", label: "Frío (con hielo)", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "cafe-helado", 
    name: "Café Helado", 
    price: 2.80, 
    category: "Bebidas Frías", 
    subcategory: "Cafés Fríos", 
    tags: ["con-lactosa"],
    customizationGroups: [
      {
        id: "leche",
        title: "🥛 Selección de Leche",
        required: false,
        type: "radio",
        options: [
          { id: "entera", label: "Leche Entera", price: 0 },
          { id: "desnatada", label: "Leche Desnatada", price: 0 },
          { id: "sin-lactosa", label: "Sin Lactosa", price: 0.05 },
          { id: "soja", label: "Bebida de Soja", price: 0.05 },
          { id: "avena", label: "Bebida de Avena", price: 0.05 },
        ]
      }
    ]
  },

  // === BEBIDAS CALIENTES ===
  { id: "cafe-solo", name: "Café Solo", price: 1.10, category: "Bebidas Calientes", subcategory: "Cafés Tradicionales" },
  { 
    id: "cortado-corto", 
    name: "Cortado Corto", 
    price: 1.20, 
    category: "Bebidas Calientes", 
    subcategory: "Cafés Tradicionales", 
    tags: ["con-lactosa"],
    customizationGroups: [
      {
        id: "leche",
        title: "🥛 Selección de Leche",
        required: false,
        type: "radio",
        options: [
          { id: "entera", label: "Leche Entera", price: 0 },
          { id: "desnatada", label: "Leche Desnatada", price: 0 },
          { id: "sin-lactosa", label: "Sin Lactosa", price: 0.05 },
          { id: "soja", label: "Bebida de Soja", price: 0.05 },
          { id: "avena", label: "Bebida de Avena", price: 0.05 },
        ]
      },
      {
        id: "temperatura",
        title: "🌡️ Temperatura de la Leche",
        required: false,
        type: "radio",
        options: [
          { id: "caliente", label: "Leche Caliente", price: 0 },
          { id: "templada", label: "Leche Templada", price: 0 },
          { id: "fria", label: "Leche Fría", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "cafe-con-leche", 
    name: "Café con Leche", 
    price: 1.60, 
    category: "Bebidas Calientes", 
    subcategory: "Cafés Tradicionales", 
    tags: ["con-lactosa"],
    customizationGroups: [
      {
        id: "leche",
        title: "🥛 Selección de Leche",
        required: false,
        type: "radio",
        options: [
          { id: "entera", label: "Leche Entera", price: 0 },
          { id: "desnatada", label: "Leche Desnatada", price: 0 },
          { id: "sin-lactosa", label: "Sin Lactosa", price: 0.05 },
          { id: "soja", label: "Bebida de Soja", price: 0.05 },
          { id: "avena", label: "Bebida de Avena", price: 0.05 },
        ]
      },
      {
        id: "temperatura",
        title: "🌡️ Temperatura de la Leche",
        required: false,
        type: "radio",
        options: [
          { id: "caliente", label: "Leche Caliente", price: 0 },
          { id: "templada", label: "Leche Templada", price: 0 },
          { id: "fria", label: "Leche Fría", price: 0 },
        ]
      }
    ]
  },
  { id: "cafe-solo-maquina", name: "Café Solo Máquina", price: 1.30, category: "Bebidas Calientes", subcategory: "Cafés Tradicionales" },
  { 
    id: "capuchino", 
    name: "Capuchino", 
    price: 1.65, 
    category: "Bebidas Calientes", 
    subcategory: "Cafés Tradicionales", 
    tags: ["con-lactosa"],
    customizationGroups: [
      {
        id: "leche",
        title: "🥛 Selección de Leche",
        required: false,
        type: "radio",
        options: [
          { id: "entera", label: "Leche Entera", price: 0 },
          { id: "desnatada", label: "Leche Desnatada", price: 0 },
          { id: "sin-lactosa", label: "Sin Lactosa", price: 0.05 },
          { id: "soja", label: "Bebida de Soja", price: 0.05 },
          { id: "avena", label: "Bebida de Avena", price: 0.05 },
        ]
      },
      {
        id: "temperatura",
        title: "🌡️ Temperatura de la Leche",
        required: false,
        type: "radio",
        options: [
          { id: "caliente", label: "Leche Caliente", price: 0 },
          { id: "templada", label: "Leche Templada", price: 0 },
          { id: "fria", label: "Leche Fría", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "condensado-corto", 
    name: "Condensado Corto", 
    price: 1.25, 
    category: "Bebidas Calientes", 
    subcategory: "Condensado", 
    tags: ["con-lactosa"],
    customizationGroups: [
      {
        id: "temperatura",
        title: "🌡️ Temperatura",
        required: false,
        type: "radio",
        options: [
          { id: "caliente", label: "Muy Caliente", price: 0 },
          { id: "templada", label: "Templado", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "condensado-largo", 
    name: "Condensado Largo", 
    price: 1.65, 
    category: "Bebidas Calientes", 
    subcategory: "Condensado", 
    tags: ["con-lactosa"],
    customizationGroups: [
      {
        id: "temperatura",
        title: "🌡️ Temperatura",
        required: false,
        type: "radio",
        options: [
          { id: "caliente", label: "Muy Caliente", price: 0 },
          { id: "templada", label: "Templado", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "descafeinado-corto", 
    name: "Descafeinado Corto", 
    price: 1.30, 
    category: "Bebidas Calientes", 
    subcategory: "Descafeinado", 
    tags: ["con-lactosa"],
    customizationGroups: [
      {
        id: "leche",
        title: "🥛 Selección de Leche",
        required: false,
        type: "radio",
        options: [
          { id: "entera", label: "Leche Entera", price: 0 },
          { id: "desnatada", label: "Leche Desnatada", price: 0 },
          { id: "sin-lactosa", label: "Sin Lactosa", price: 0.05 },
          { id: "soja", label: "Bebida de Soja", price: 0.05 },
          { id: "avena", label: "Bebida de Avena", price: 0.05 },
        ]
      },
      {
        id: "temperatura",
        title: "🌡️ Temperatura de la Leche",
        required: false,
        type: "radio",
        options: [
          { id: "caliente", label: "Leche Caliente", price: 0 },
          { id: "templada", label: "Leche Templada", price: 0 },
          { id: "fria", label: "Leche Fría", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "descafeinado-largo", 
    name: "Descafeinado Largo", 
    price: 1.65, 
    category: "Bebidas Calientes", 
    subcategory: "Descafeinado", 
    tags: ["con-lactosa"],
    customizationGroups: [
      {
        id: "leche",
        title: "🥛 Selección de Leche",
        required: false,
        type: "radio",
        options: [
          { id: "entera", label: "Leche Entera", price: 0 },
          { id: "desnatada", label: "Leche Desnatada", price: 0 },
          { id: "sin-lactosa", label: "Sin Lactosa", price: 0.05 },
          { id: "soja", label: "Bebida de Soja", price: 0.05 },
          { id: "avena", label: "Bebida de Avena", price: 0.05 },
        ]
      },
      {
        id: "temperatura",
        title: "🌡️ Temperatura de la Leche",
        required: false,
        type: "radio",
        options: [
          { id: "caliente", label: "Leche Caliente", price: 0 },
          { id: "templada", label: "Leche Templada", price: 0 },
          { id: "fria", label: "Leche Fría", price: 0 },
        ]
      }
    ]
  },
  { id: "cafe-leche-sinlactosa", name: "Café con Leche sin Lactosa / Avena / Soja", price: 1.65, category: "Bebidas Calientes", subcategory: "Opciones Sin Lactosa", tags: ["sin-lactosa"] },
  { id: "cortado-sinlactosa", name: "Cortado Corto sin Lactosa / Avena / Soja", price: 1.25, category: "Bebidas Calientes", subcategory: "Opciones Sin Lactosa", tags: ["sin-lactosa"] },
  { id: "infusiones", name: "Infusiones Especiales", price: 1.50, category: "Bebidas Calientes", subcategory: "Chocolates e Infusiones", tags: ["vegetariano"] },
  { 
    id: "colacao", 
    name: "ColaCao / Chocolate Caliente", 
    price: 1.50, 
    category: "Bebidas Calientes", 
    subcategory: "Chocolates e Infusiones", 
    tags: ["con-lactosa"],
    customizationGroups: [
      {
        id: "leche",
        title: "🥛 Selección de Leche",
        required: false,
        type: "radio",
        options: [
          { id: "entera", label: "Leche Entera", price: 0 },
          { id: "desnatada", label: "Leche Desnatada", price: 0 },
          { id: "sin-lactosa", label: "Sin Lactosa", price: 0.05 },
          { id: "soja", label: "Bebida de Soja", price: 0.05 },
          { id: "avena", label: "Bebida de Avena", price: 0.05 },
        ]
      },
      {
        id: "temperatura",
        title: "🌡️ Temperatura",
        required: false,
        type: "radio",
        options: [
          { id: "caliente", label: "Muy Caliente", price: 0 },
          { id: "templada", label: "Templado", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "taza-chocolate", 
    name: "Taza de Chocolate", 
    price: 1.60, 
    category: "Bebidas Calientes", 
    subcategory: "Chocolates e Infusiones", 
    tags: ["con-lactosa"],
    customizationGroups: [
      {
        id: "leche",
        title: "🥛 Selección de Leche",
        required: false,
        type: "radio",
        options: [
          { id: "entera", label: "Leche Entera", price: 0 },
          { id: "sin-lactosa", label: "Sin Lactosa", price: 0.05 },
        ]
      }
    ]
  },

  // === SALADO (con grupos de personalización) ===
  { id: "croissant-normal", name: "Croissant Normal", price: 1.20, category: "Salado", subcategory: "Croissants", tags: ["vegetariano"] },
  { 
    id: "croissant-vegetal", 
    name: "Croissant Vegetal", 
    price: 2.10, 
    category: "Salado", 
    subcategory: "Croissants", 
    tags: ["vegetariano"],
    customizationGroups: [
      {
        id: "ingredientes",
        title: "🥗 Quitar Ingredientes",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-tomate", label: "Sin Tomate", price: 0 },
          { id: "no-lechuga", label: "Sin Lechuga", price: 0 },
          { id: "no-mayonesa", label: "Sin Mayonesa", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "croissant-mixto", 
    name: "Croissant Mixto", 
    price: 2.10, 
    category: "Salado", 
    subcategory: "Croissants",
    customizationGroups: [
      {
        id: "ingredientes",
        title: "🥗 Quitar Ingredientes",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-queso", label: "Sin Queso", price: 0 },
          { id: "no-jamon", label: "Sin Jamón", price: 0 },
        ]
      },
      {
        id: "pan",
        title: "🍞 Preferencia de Pan",
        required: false,
        type: "radio",
        options: [
          { id: "normal", label: "Tostado Normal", price: 0 },
          { id: "muy-tostado", label: "Muy Tostado", price: 0 },
          { id: "poco-hecho", label: "Poco Hecho", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "croissant-serrano", 
    name: "Croissant Serrano", 
    price: 2.80, 
    category: "Salado", 
    subcategory: "Croissants",
    customizationGroups: [
      {
        id: "ingredientes",
        title: "🥗 Quitar Ingredientes",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-tomate", label: "Sin Tomate", price: 0 },
          { id: "no-queso", label: "Sin Queso", price: 0 },
        ]
      },
      {
        id: "pan",
        title: "🍞 Preferencia de Pan",
        required: false,
        type: "radio",
        options: [
          { id: "normal", label: "Tostado Normal", price: 0 },
          { id: "muy-tostado", label: "Muy Tostado", price: 0 },
          { id: "poco-hecho", label: "Poco Hecho", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "croissant-vegetal-mixto", 
    name: "Croissant Vegetal Mixto", 
    price: 2.70, 
    category: "Salado", 
    subcategory: "Croissants",
    customizationGroups: [
      {
        id: "ingredientes",
        title: "🥗 Quitar Ingredientes",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-tomate", label: "Sin Tomate", price: 0 },
          { id: "no-lechuga", label: "Sin Lechuga", price: 0 },
          { id: "no-mayonesa", label: "Sin Mayonesa", price: 0 },
          { id: "no-queso", label: "Sin Queso", price: 0 },
          { id: "no-jamon", label: "Sin Jamón", price: 0 },
        ]
      },
      {
        id: "pan",
        title: "🍞 Preferencia de Pan",
        required: false,
        type: "radio",
        options: [
          { id: "normal", label: "Tostado Normal", price: 0 },
          { id: "muy-tostado", label: "Muy Tostado", price: 0 },
          { id: "poco-hecho", label: "Poco Hecho", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "caracola-atun", 
    name: "Caracola Vegetal Atún", 
    price: 2.30, 
    category: "Salado", 
    subcategory: "Caracolas",
    customizationGroups: [
      {
        id: "ingredientes",
        title: "🥗 Quitar Ingredientes",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-tomate", label: "Sin Tomate", price: 0 },
          { id: "no-lechuga", label: "Sin Lechuga", price: 0 },
          { id: "no-mayonesa", label: "Sin Mayonesa", price: 0 },
          { id: "no-cebolla", label: "Sin Cebolla", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "caracola-pavo", 
    name: "Caracola Vegetal Pavo", 
    price: 2.80, 
    category: "Salado", 
    subcategory: "Caracolas",
    customizationGroups: [
      {
        id: "ingredientes",
        title: "🥗 Quitar Ingredientes",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-tomate", label: "Sin Tomate", price: 0 },
          { id: "no-lechuga", label: "Sin Lechuga", price: 0 },
          { id: "no-mayonesa", label: "Sin Mayonesa", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "caracola-atun-mixto", 
    name: "Caracola Vegetal Atún Mixto", 
    price: 2.90, 
    category: "Salado", 
    subcategory: "Caracolas",
    customizationGroups: [
      {
        id: "ingredientes",
        title: "🥗 Quitar Ingredientes",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-tomate", label: "Sin Tomate", price: 0 },
          { id: "no-lechuga", label: "Sin Lechuga", price: 0 },
          { id: "no-mayonesa", label: "Sin Mayonesa", price: 0 },
          { id: "no-cebolla", label: "Sin Cebolla", price: 0 },
          { id: "no-queso", label: "Sin Queso", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "sandwich-mixto", 
    name: "Sándwich Mixto", 
    price: 2.00, 
    category: "Salado", 
    subcategory: "Sándwiches y Bocadillos",
    customizationGroups: [
      {
        id: "ingredientes",
        title: "🥗 Quitar Ingredientes",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-queso", label: "Sin Queso", price: 0 },
          { id: "no-jamon", label: "Sin Jamón", price: 0 },
        ]
      },
      {
        id: "pan",
        title: "🍞 Preferencia de Pan",
        required: false,
        type: "radio",
        options: [
          { id: "normal", label: "Tostado Normal", price: 0 },
          { id: "muy-tostado", label: "Muy Tostado", price: 0 },
          { id: "poco-hecho", label: "Poco Hecho", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "pulguita-pollo", 
    name: "Pulguita de Pollo", 
    price: 2.80, 
    category: "Salado", 
    subcategory: "Sándwiches y Bocadillos",
    customizationGroups: [
      {
        id: "ingredientes",
        title: "🥗 Quitar Ingredientes",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-lechuga", label: "Sin Lechuga", price: 0 },
          { id: "no-tomate", label: "Sin Tomate", price: 0 },
          { id: "no-mayonesa", label: "Sin Mayonesa", price: 0 },
        ]
      },
      {
        id: "pan",
        title: "🍞 Preferencia de Pan",
        required: false,
        type: "radio",
        options: [
          { id: "normal", label: "Tostado Normal", price: 0 },
          { id: "muy-tostado", label: "Muy Tostado", price: 0 },
          { id: "poco-hecho", label: "Poco Hecho", price: 0 },
        ]
      }
    ]
  },
  { 
    id: "sandwich-atun-queso", 
    name: "Sándwich de Atún y Queso Fundido", 
    price: 2.80, 
    category: "Salado", 
    subcategory: "Sándwiches y Bocadillos",
    customizationGroups: [
      {
        id: "ingredientes",
        title: "🥗 Quitar Ingredientes",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-cebolla", label: "Sin Cebolla", price: 0 },
          { id: "no-queso", label: "Sin Queso", price: 0 },
        ]
      },
      {
        id: "pan",
        title: "🍞 Preferencia de Pan",
        required: false,
        type: "radio",
        options: [
          { id: "normal", label: "Tostado Normal", price: 0 },
          { id: "muy-tostado", label: "Muy Tostado", price: 0 },
          { id: "poco-hecho", label: "Poco Hecho", price: 0 },
        ]
      }
    ]
  },

  // === MENÚS ===
  { id: "menu-croissant-vegetal", name: "Menú Croissant Vegetal", price: 5.00, category: "Menús", subcategory: "Menús Clásicos", tags: ["vegetariano"] },
  { id: "menu-sandwich-mixto", name: "Menú Sándwich Mixto", price: 5.00, category: "Menús", subcategory: "Menús Clásicos" },
  { id: "menu-croissant-nutella", name: "Menú Croissant Nutella", price: 5.00, category: "Menús", subcategory: "Menús Clásicos", tags: ["vegetariano"] },
  { id: "menu-croissant-mixto", name: "Menú Croissant Mixto", price: 5.30, category: "Menús", subcategory: "Menús Clásicos" },
  { id: "menu-caracola-atun", name: "Menú Caracola Atún", price: 5.30, category: "Menús", subcategory: "Menús Clásicos" },
  { id: "menu-croissant-serrano", name: "Menú Croissant Serrano", price: 5.30, category: "Menús", subcategory: "Menús Clásicos" },
  { id: "menu-croissant-vegetal-mixto", name: "Menú Croissant Vegetal Mixto", price: 5.30, category: "Menús", subcategory: "Menús Clásicos" },
  { id: "menu-sandwich-atun", name: "Menú Sándwich Atún y Queso Fundido", price: 5.90, category: "Menús", subcategory: "⭐ Menús Especiales" },
  { id: "menu-pulguita", name: "Menú Pulguita Pollo", price: 5.90, category: "Menús", subcategory: "⭐ Menús Especiales" },
  { id: "menu-caracola-pavo", name: "Menú Caracola Pavo", price: 5.90, category: "Menús", subcategory: "⭐ Menús Especiales" },
  { id: "menu-caracola-atun-mixta", name: "Menú Caracola Atún Mixta", price: 5.90, category: "Menús", subcategory: "⭐ Menús Especiales" },

  // === ENCARGOS (Tartas por Encargo) con customizationGroups ===
  // GRUPO A: Chocolate y Frutos Secos (Riesgo Alérgenos)
  { 
    id: "ferrero", 
    name: "Ferrero", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Chocolate y Frutos Secos",
    description: "Bizcocho de chocolate con crema de avellanas y Ferrero Rocher",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-hazelnuts", label: "Sin Avellanas (decoración)", price: 0 },
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "extra-ferrero", label: "Ferrero Rocher Extra (4 uds)", price: 3.00 },
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },
  { 
    id: "nutella", 
    name: "Nutella", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Chocolate y Frutos Secos",
    description: "Bizcocho con crema de Nutella y cobertura de chocolate",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-hazelnuts", label: "Sin Avellanas (decoración)", price: 0 },
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "extra-nutella", label: "Cobertura Nutella Extra", price: 2.50 },
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },
  { 
    id: "marmolada", 
    name: "Marmolada (Turrón, Vainilla y Chocolates)", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Chocolate y Frutos Secos",
    description: "Capas de bizcocho de vainilla y chocolate con turrón",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-turron", label: "Sin Turrón (contiene almendra)", price: 0 },
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "extra-choc", label: "Virutas de Chocolate Extra", price: 1.50 },
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },
  { 
    id: "merengue-turron", 
    name: "Merengue Tostado y Turrón", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Chocolate y Frutos Secos",
    description: "Tarta con merengue tostado y trocitos de turrón",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-turron", label: "Sin Trocitos de Turrón", price: 0 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "extra-merengue", label: "Merengue Tostado Extra", price: 1.50 },
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },
  { 
    id: "semibañadas", 
    name: "Semibañadas o Bañadas en Chocolate", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Chocolate y Frutos Secos",
    description: "Tarta con cobertura parcial o total de chocolate",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "full-cover", label: "Cobertura Completa de Chocolate", price: 3.00 },
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },

  // GRUPO B: Nata y Frutas (Lácteos Críticos)
  { 
    id: "fresas-nata", 
    name: "Fresas Naturales y Nata", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Nata y Frutas",
    description: "Bizcocho con nata montada y fresas frescas",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
          { id: "no-strawberries", label: "Sin Fresas (solo nata)", price: 0 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "extra-strawberries", label: "Fresas Extra", price: 2.50 },
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },
  { 
    id: "frutas-nata-merengue", 
    name: "Frutas Variadas con Nata/Merengue", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Nata y Frutas",
    description: "Selección de frutas de temporada con nata o merengue",
    customizationGroups: [
      {
        id: "base",
        title: "🍰 Base de la Tarta",
        required: false,
        type: "radio",
        options: [
          { id: "nata", label: "Con Nata", price: 0 },
          { id: "merengue", label: "Con Merengue", price: 0 },
        ]
      },
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
          { id: "no-fruit", label: "Sin Fruta (decoración simple)", price: 0 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },
  { 
    id: "selva-negra", 
    name: "Selva Negra", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Nata y Frutas",
    description: "Clásica tarta alemana con nata, cerezas y licor Kirsch",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-alcohol", label: "Sin Alcohol (Kirsch)", price: 0 },
          { id: "no-cherries", label: "Sin Cerezas", price: 0 },
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "extra-cherries", label: "Cerezas Extra", price: 1.50 },
          { id: "extra-choc", label: "Virutas de Chocolate Extra", price: 1.50 },
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },
  { 
    id: "crema-catalana", 
    name: "Crema Catalana", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Nata y Frutas",
    description: "Cremoso postre catalán con azúcar caramelizado",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-caramel", label: "Sin Azúcar Quemado (Caramelo)", price: 0 },
          { id: "lactose-free", label: "Crema Sin Lactosa", price: 2.00 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },

  // GRUPO C: Especialidades y Galletas
  { 
    id: "lotus", 
    name: "Lotus", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Especialidades",
    description: "Tarta con crema de galleta Lotus Biscoff",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-cookie", label: "Sin Galleta Decorativa", price: 0 },
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "extra-lotus", label: "Crema Lotus Extra", price: 2.00 },
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },
  { 
    id: "oreo", 
    name: "Oreo", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Especialidades",
    description: "Tarta con crema de Oreo y trocitos de galleta",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-cookie", label: "Sin Galleta Decorativa", price: 0 },
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "extra-oreo", label: "Galletas Oreo Extra", price: 1.50 },
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },
  { 
    id: "polvito-uruguayo", 
    name: "Polvito Uruguayo", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Especialidades",
    description: "Postre uruguayo con dulce de leche, nata y merengue",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-suspiros", label: "Sin Suspiros (Merengue seco)", price: 0 },
          { id: "no-dulce-leche", label: "Sin Dulce de Leche (solo nata)", price: 0 },
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "extra-dulce", label: "Dulce de Leche Extra", price: 2.00 },
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },
  { 
    id: "turron-chocolate-caramelo-vainilla", 
    name: "Turrón/Chocolate/Caramelo/Vainilla con Nata o Merengue", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Especialidades",
    description: "Variedad de sabores con base de nata o merengue",
    customizationGroups: [
      {
        id: "base",
        title: "🍰 Base de la Tarta",
        required: false,
        type: "radio",
        options: [
          { id: "nata", label: "Con Nata", price: 0 },
          { id: "merengue", label: "Con Merengue", price: 0 },
        ]
      },
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-turron", label: "Sin Trocitos de Turrón", price: 0 },
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },

  // GRUPO D: Cítricos y Mousse
  { 
    id: "merengue-limon", 
    name: "Merengue y Limón", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Cítricos y Mousse",
    description: "Tarta de limón con merengue tostado",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "no-merengue", label: "Sin Merengue (solo crema de limón)", price: 0 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "extra-merengue", label: "Merengue Tostado Extra", price: 1.50 },
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },
  { 
    id: "semifrias", 
    name: "Semifrías", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Cítricos y Mousse",
    description: "Tartas semifrías con diversas variedades",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },
  { 
    id: "tartaletas-semifrias", 
    name: "Tartaletas Semifrías Grandes", 
    price: 0, 
    category: "Encargos", 
    subcategory: "Cítricos y Mousse",
    description: "Tartaletas individuales grandes semifrías",
    customizationGroups: [
      {
        id: "alergenos",
        title: "🚨 Alérgenos y Sustituciones",
        required: false,
        type: "checkbox",
        options: [
          { id: "lactose-free", label: "Nata Sin Lactosa", price: 2.00 },
        ]
      },
      {
        id: "extras",
        title: "✨ Extras",
        required: false,
        type: "checkbox",
        options: [
          { id: "dedicatoria", label: "Cartel de Felicitación", price: 2.00 },
        ]
      }
    ]
  },

  // === TEST (producto de prueba para Encargos) ===
  { 
    id: "encargo-test", 
    name: "Encargo de Prueba (0.50€)", 
    price: 0.50, 
    category: "Encargos", 
    subcategory: "Producto de Prueba",
    description: "Producto para probar el flujo de pago de encargos",
    customizationGroups: [
      {
        id: "test-options",
        title: "🧪 Opciones de Prueba",
        required: false,
        type: "checkbox",
        options: [
          { id: "test-extra", label: "Extra de Prueba", price: 0.25 },
          { id: "test-free", label: "Opción Gratuita", price: 0 },
        ]
      }
    ]
  },
];

// Helper to get product by ID
export const getProductById = (id: string): ProductDefinition | undefined => {
  return PRODUCT_CATALOG.find(p => p.id === id);
};

// Helper to get removable ingredients for a product (legacy support)
export const getRemovableIngredients = (productId: string): string[] => {
  const product = getProductById(productId);
  return product?.removableIngredients || [];
};

// Check if a product has customization options (legacy or new)
export const hasCustomization = (productId: string): boolean => {
  const product = getProductById(productId);
  if (!product) return false;
  
  // Check new customization groups
  if (product.customizationGroups && product.customizationGroups.length > 0) {
    return true;
  }
  
  // Check legacy removable ingredients
  return !!product.removableIngredients && product.removableIngredients.length > 0;
};

// Get encargo products only
export const getEncargoProducts = (): ProductDefinition[] => {
  return PRODUCT_CATALOG.filter(p => p.category === "Encargos");
};
